export const MEDIA_SIZE = {
  SMALL: '768px',
  MEDIUM: '875px',
  LARGE: '1170px'
}

export const MEDIA_QUERY = {
  MOBILE: `(max-width: ${MEDIA_SIZE.SMALL})`,
  DESKTOP: `(min-width: ${MEDIA_SIZE.LARGE})`,
  TABLET: `(min-width: ${MEDIA_SIZE.SMALL}) and (max-width: ${MEDIA_SIZE.LARGE})`
}

export const BORDER_RADIUS = '12px'
export const ITEM_SHADOW = '0 4px 12px -4px rgba(0, 0, 0, 0.3)'
